module.exports = __webpack_public_path__ + "static/media/falling_stars.c34f1880.png";